import React from "react";
import PropTypes from "prop-types";
import ArcPath from "./ArcPath";


function calculateTotal(items) {
  return items.reduce((sum, currItem) => sum + currItem.value, 0);
}

export default function Arcs(props) {
  const {
    size,
    data,
    active,
    onHover,
    className,
    colors,
    innerRadius,
    mounted,
    outerRadius,
    activeOffset
  } = props;
  let angle = 270;
  const total = calculateTotal(data);

  return (
    <g className={className}>
      {data.map((item,index)=>({...item, index:index})).sort((a,b)=>a.value-b.value).map((item) => {
        const { value, color, index} = item;

        const fill = color ? color : colors[index % colors.length];
        const arcPath = (
          <ArcPath
            className={`${className}-arcpath`}
            // className={`${className}-arcpath-${index}`}
            style={{transform: mounted ? 'rotate(0deg)'  : 'rotate(-'+angle+'deg)'}}
            // style={{animation: `donut-fill ${speed}s reverse`}}
            size={size}
            item={item}
            index={index}
            key={item.name}
            innerRadius={innerRadius}
            outerRadius={
              index === active ? outerRadius + activeOffset : outerRadius
            }
            fill={fill}
            angle={angle}
            total={total}
            onMouseEnter={onHover}
          />
        );
        angle += (value / total) * 360 || 0;
        return arcPath;
      })}
    </g>
  );
}

Arcs.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.number.isRequired
    })
  ).isRequired,
  active: PropTypes.number,
  onHover: PropTypes.func,
  colors: PropTypes.arrayOf(PropTypes.string),
  innerRadius: PropTypes.number,
  outerRadius: PropTypes.number,
  activeOffset: PropTypes.number
};

Arcs.defaultProps = {
  size: 500,
  className: "donut-chart",
  colors: [
    "rgb(51, 102, 204)",
    "rgb(220, 57, 18)",
    "rgb(255, 153, 0)",
    "rgb(16, 150, 24)",
    "rgb(153, 0, 153)"
  ],
  active: -1,
  // eslint-disable-next-line
  onHover: item => console.log("Hover", item),
  innerRadius: 0.65,
  outerRadius: 0.95,
  activeOffset: 0.05
};
